<template>
  <div class="white">
    <b-container>
      <b-row>
        <b-col>
          <div id="gear1" class="gear large stick_left go_up"></div>
        </b-col>
        <b-col>
          <div id="gear7" class="gear vsmall"></div>
        </b-col>
        <b-col>
          <div id="gear2" class="gear small"></div>
        </b-col>
        <b-col>
          <div id="gear3" class="gear mid"></div>
        </b-col>
        <b-col>
          <div id="gear5" class="gear vsmall"></div>
        </b-col>
        <b-col>
          <div id="gear8" class="gear vsmall"></div>
        </b-col>
        <b-col>
          <div id="gear9" class="gear vsmall"></div>
        </b-col>
        <b-col style="height: 100px">
          <div id="gear4" class="gear vlarge stick_right"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "GearsSep",
  props: {
    msg: String
  }
};
</script>

<style scoped>
.white {
  z-index: 5;
}
#gear5 {
  top: 40%;
  left: -500%;
}
.go_up {
  top: -40%;
}
.large {
  width: 256px;
  height: 256px;
  background: url(../../public/img/gears/gear256g.png);
  position: relative;
}
#gear7 {
  left: -200%;
}
#gear9 {
  top: 20%;
}
.vlarge {
  width: 512px;
  height: 512px;
  top: -600%;
  background: url(../../public/img/gears/gear512g.png);
  position: relative;
}
.stick_left {
  left: -95%;
}
.stick_right {
  position: relative;
  right: -85%;
}
.small {
  position: relative;
  top: 05%;
  left: -85%;
  width: 64px;
  height: 64px;
  background: url(../../public/img/gears/gear64g.png);
}
.mid {
  width: 128px;
  height: 128px;
  background: url(../../public/img/gears/gear128g.png);
  position: relative;
  top: -10%;
  left: -45%;
}
.vsmall {
  width: 48px;
  height: 48px;
  position: relative;
  left: -120%;
  top: -10%;
  background: url(../../public/img/gears/gear48g.png);
}
</style>
